"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyGenderTypeToJSON = exports.SurveyGenderTypeFromJSONTyped = exports.SurveyGenderTypeFromJSON = exports.SurveyGenderType = void 0;
/**
 *
 * @export
 */
exports.SurveyGenderType = {
    Male: 'MALE',
    Female: 'FEMALE'
};
function SurveyGenderTypeFromJSON(json) {
    return SurveyGenderTypeFromJSONTyped(json, false);
}
exports.SurveyGenderTypeFromJSON = SurveyGenderTypeFromJSON;
function SurveyGenderTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveyGenderTypeFromJSONTyped = SurveyGenderTypeFromJSONTyped;
function SurveyGenderTypeToJSON(value) {
    return value;
}
exports.SurveyGenderTypeToJSON = SurveyGenderTypeToJSON;
